<div class="calendar-header-container display-flex justify-content-space-between align-items-center">
  <button mat-icon-button class="nav-button" (click)="previousClicked()">
    <app-icon [iconColor]="EColorPalette.cGray7" [iconHeight]="8" [iconWidth]="14" [svg]="EIcon.ANGLE_LEFT"></app-icon>
  </button>
  <div class="header-label fs s14">{{ periodLabel }}</div>
  <button mat-icon-button class="nav-button" (click)="nextClicked()">
    <app-icon [iconColor]="EColorPalette.cGray7" [iconHeight]="8" [iconWidth]="14" [svg]="EIcon.ANGLE_RIGHT"></app-icon>
  </button>
</div>
